import SurveyDaysAdditionalDetailsViewModel from "./SurveyDaysAdditionalDetailsViewModel";

export default class ServiceVehiclesViewModel {
    id: string = '';
    arrivals: string[] = [];
    departures: string[] = [];
    comment: string = ''; 
    additionalDetails: SurveyDaysAdditionalDetailsViewModel = new SurveyDaysAdditionalDetailsViewModel();
}
